import { IFilter } from "../models/filters/filter";
import { ISamplingEventFilter } from "../models/filters/samplingEventFilter";
import { ISamplingEventForm } from "../models/forms/samplingEventForm";
import { ISamplingEventPDTO } from "../models/dtos/samplingEventPDTO";
import _o2sService from "./_o2sServices";
import { API_CENTRE } from "./config";

export default class SamplingEventServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/samplingevents";

    protected static override getUrlFilter<F extends ISamplingEventFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {

        }
        return url;
    }

    protected static override toDTO(obj: ISamplingEventForm): ISamplingEventPDTO {
        const dto = super.toDTO(obj) as ISamplingEventPDTO;
        return dto;
    }
}